import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixCloudDataUsageV1SiteDataUsageServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_data-site-usage-service_data';

/** Get current site data usage */
export function getSiteDataUsage(payload: object): RequestOptionsFactory<any> {
  function __getSiteDataUsage({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.cloud.data_usage.v1.site_data_usage',
      method: 'GET' as any,
      methodFqn:
        'wix.cloud.data_usage.v1.SiteDataUsageService.GetSiteDataUsage',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCloudDataUsageV1SiteDataUsageServiceUrl({
        protoPath: '/v1/site-data-usage',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getSiteDataUsage;
}
